import * as wjcFlexGridColumnPicker from "./flex-grid-column-picker";

"use strict";

import { Inject, Directive, Self } from "@angular/core";
import * as ngCore from "@angular/core";
import * as WjFlexGrid from "@grapecity/wijmo.angular2.grid";
import { ModalWrapperService } from "../services";

@Directive({
    selector: "[columnPicker]",
    inputs: ["columnPicker"],
    standalone: false
})
export class ColumnPicker implements ngCore.OnInit, ngCore.OnDestroy {
    columnPicker: string;
    private _frame: HTMLElement;
    private _img: HTMLElement;

    constructor(
        @Self()
        @Inject(WjFlexGrid.WjFlexGrid)
        private _flex: WjFlexGrid.WjFlexGrid,
        private _modalSvc: ModalWrapperService
    ) {}

    ngOnInit() {
        if (!this._flex) {
            return;
        }

        const cp = new wjcFlexGridColumnPicker.FlexGridColumnPicker(
            this._flex,
            this.columnPicker,
            this._modalSvc
        );
    }

    ngOnDestroy() {
        this._flex.invalidate();
    }
}
